<template>
  <div>
    <simpletoolbar></simpletoolbar>
    <br/>
    <div class="columns">
      <div class="column is-one-fifth">
      </div>
      <div class="column is-three-fifths">
        <fix-translation-card></fix-translation-card>
        <hr>
        <add-translation-card></add-translation-card>
        <hr>
        <translators-card></translators-card>
      </div>
      <div class="column is-one-fifth">
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import simpletoolbar from '@components/ui/simpletoolbar.vue';
import fixTranslationCard from '@components/shared/fixTranslationCard.vue';
import addTranslationCard from '@components/shared/addTranslationCard.vue';
import translatorsCard from '@components/shared/translatorsCard.vue';

onMounted(() => {
  document.title = 'Translations';
});
</script>
